export const resolveCountBadgeCountText = (
  count: number,
  formatNumber: (value: number) => string,
  maxCount?: number,
) =>
  maxCount !== undefined && count > maxCount
    ? `${formatNumber(maxCount)}+`
    : formatNumber(count);
